// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const CheckIcon = (props: IconProps) => (
  <Icon viewBox="0 0 17 13" fill="none" {...props}>
    <path d="M1.3335 6.26141L6.04754 10.9755L15.4756 1.54737" stroke="#4D3D8D" strokeWidth="2" strokeLinecap="round" />
  </Icon>
);
